export default "__VITE_ASSET__Fy6x8YzB__"